class ColumnCountSelector extends HTMLElement {
  constructor() {
    super();
    this.initValue = Number(this.getAttribute('data-per-row')) || 3;
    this.items = this.querySelectorAll('.collection-filter__item--column');
    this.container = document.querySelector('[data-product-grid]');
    this.init();
  }

  init = () => {
    if (!this.container) {
      return;
    }
    this.items.forEach((item, itemIndex) => {
      const index =
        Number(item.getAttribute('data-count-amount')) || itemIndex + 1;
      if (index === this.initValue) {
        item.classList.add('collection-filter__item--column-active');
      } else {
        item.classList.remove('collection-filter__item--column-active');
      }
      item.addEventListener('click', this.onItemClick);
    });
  };

  onItemClick = (e) => {
    const el = e.currentTarget;
    const index = Number(el.getAttribute('data-count-amount')) || null;
    if (!index) {
      return;
    }
    this.deactiveAllItems();
    el.classList.add('collection-filter__item--column-active');
    this.container.style.setProperty('--gridCount', index);

    if (window.AOS) {
      AOS.refresh();
    }
  };

  deactiveAllItems = () =>
    this.items.forEach((item) => {
      item.classList.remove('collection-filter__item--column-active');
    });
}

if (!customElements.get('column-count-selector')) {
  customElements.define('column-count-selector', ColumnCountSelector);
}
